module.exports = __webpack_public_path__ + "media/images/pictograms/pic5-5616f08ecb2769f9f86d51dedb30b6ff.png";